"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[227],{

/***/ 82227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ src_GlobalHooks; }
});

// EXTERNAL MODULE: ./src/hooks/useActionQueryListener.ts
var useActionQueryListener = __webpack_require__(66064);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/state/auth/hooks.ts
var hooks = __webpack_require__(71581);
;// CONCATENATED MODULE: ./src/hooks/useSentryUser.ts




function useSentryUser() {
  var _useUserInfo = (0,hooks/* useUserInfo */.Pc)(),
      username = _useUserInfo.username,
      uid = _useUserInfo.uid;

  (0,react.useEffect)(function () {
    if (username && uid) {
      (0,esm_exports/* setUser */.av)({
        username: username,
        uid: uid
      });
    } else {
      (0,esm_exports/* configureScope */.e)(function (scope) {
        return scope.setUser(null);
      });
    }
  }, [username, uid]);
}

/* harmony default export */ var hooks_useSentryUser = (useSentryUser);
// EXTERNAL MODULE: ./src/state/system/hooks.ts
var system_hooks = __webpack_require__(44602);
// EXTERNAL MODULE: ./src/state/profile/hooks.ts + 1 modules
var profile_hooks = __webpack_require__(57534);
// EXTERNAL MODULE: ./src/state/transaction/hooks.tsx + 2 modules
var transaction_hooks = __webpack_require__(89030);
;// CONCATENATED MODULE: ./src/hooks/useUpdateScreenHeight.ts

var useUpdateScreenHeight = function useUpdateScreenHeight() {
  (0,react.useEffect)(function () {
    window.onresize = function () {
      var _window;

      (_window = window) === null || _window === void 0 ? void 0 : _window.document.documentElement.style.setProperty('--screen-height', "".concat(window.innerHeight, "px"));
    };
  }, []);
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./src/config/constants/network.ts
var network = __webpack_require__(17961);
// EXTERNAL MODULE: ./src/state/index.ts + 15 modules
var state = __webpack_require__(82813);
// EXTERNAL MODULE: ./src/hooks/useAnalytics.ts
var useAnalytics = __webpack_require__(42705);
;// CONCATENATED MODULE: ./src/hooks/useAnalyticsUser.ts







function useAnalyticsUser() {
  var _useAuth = (0,hooks/* useAuth */.aC)(),
      username = _useAuth.username,
      uid = _useAuth.uid,
      loginBy = _useAuth.loginBy,
      isSigned = _useAuth.isSigned;

  var info = (0,state/* useAppSelector */.CG)(function (state) {
    return state.profile.info;
  });
  var wallet = (0,state/* useAppSelector */.CG)(function (state) {
    return state.auth.wallet;
  });

  var _useAnalytics = (0,useAnalytics/* useAnalytics */.z)(),
      updateUserId = _useAnalytics.updateUserId,
      updateUserType = _useAnalytics.updateUserType,
      recordEvent = _useAnalytics.recordEvent;

  var selectToken = (0,state/* useAppSelector */.CG)(function (state) {
    return state.app.selectToken;
  });
  var refToken = (0,react.useRef)(selectToken);
  (0,react.useEffect)(function () {
    if (username && uid) {
      updateUserId(uid.toString());
      updateUserType('type', loginBy);
    } else {
      updateUserId(null);
    }
  }, [username, uid, updateUserId, updateUserType, loginBy]);
  (0,react.useEffect)(function () {
    if (isSigned && refToken.current !== selectToken) {
      updateUserType('coin', "".concat(network/* ChainIdEnum */.Li[selectToken.network], " | ").concat(selectToken.token));
      recordEvent('select_balance', (0,defineProperty/* default */.Z)({}, network/* ChainIdEnum */.Li[selectToken.network], selectToken.token));
      refToken.current = selectToken;
    }
  }, [isSigned, recordEvent, selectToken, updateUserType]); // useEffect(() => {
  //   if (info) {
  //     updateUserType('address', info.address.toString());
  //   }
  // }, [info, updateUserType]);

  (0,react.useEffect)(function () {
    if (wallet !== null && wallet !== void 0 && wallet.trackingName) updateUserType('wallet', wallet === null || wallet === void 0 ? void 0 : wallet.trackingName);
  }, [updateUserType, wallet]);
}

/* harmony default export */ var hooks_useAnalyticsUser = (useAnalyticsUser);
// EXTERNAL MODULE: ./src/config/constants/languages.ts
var languages = __webpack_require__(83592);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 6 modules
var useTranslation = __webpack_require__(18132);
;// CONCATENATED MODULE: ./src/hooks/useLanguageChangeEventListener.ts



var useLanguageChangeEventListener = function useLanguageChangeEventListener() {
  var _useTranslation = (0,useTranslation/* useTranslation */.$)(),
      i18n = _useTranslation.i18n;

  (0,react.useEffect)(function () {
    var init = function init() {
      var selectedLanguage = languages/* LANGUAGES.find */.a.find(function (item) {
        return item.code === i18n.language;
      });

      if (selectedLanguage !== null && selectedLanguage !== void 0 && selectedLanguage.ISO) {
        document.querySelector('html').lang = selectedLanguage.ISO;
      }
    };

    init();
  }, [i18n.language]);
};
// EXTERNAL MODULE: ./src/state/bonus/hooks.ts + 1 modules
var bonus_hooks = __webpack_require__(2309);
;// CONCATENATED MODULE: ./src/GlobalHooks.tsx










var GlobalHooks = function GlobalHooks() {
  (0,system_hooks/* usePollSystemData */.Y)();
  (0,profile_hooks/* usePollUserProfile */.yi)();
  (0,profile_hooks/* useUpdateUserToken */.h7)();
  hooks_useSentryUser();
  hooks_useAnalyticsUser();
  (0,profile_hooks/* usePollUserBalances */.ZC)();
  (0,useActionQueryListener/* default */.ZP)();
  (0,transaction_hooks/* usePollPendingTransaction */.aA)();
  useLanguageChangeEventListener();
  useUpdateScreenHeight();
  (0,bonus_hooks/* useActivatedBonusesUpdater */.SL)();
  return null;
};

/* harmony default export */ var src_GlobalHooks = (GlobalHooks);

/***/ }),

/***/ 31055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(92777);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(82262);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(45959);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37247);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var config_constants_server__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25920);
/* harmony import */ var _BaseRequest__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55748);
/* harmony import */ var _HunnyPokerRequest__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84055);
/* harmony import */ var _mapper_Mapper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29901);








function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_getPrototypeOf_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }






var MetaService = /*#__PURE__*/function (_HunnyPokerRequest) {
  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_inherits_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(MetaService, _HunnyPokerRequest);

  var _super = _createSuper(MetaService);

  function MetaService() {
    (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_classCallCheck_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(this, MetaService);

    return _super.apply(this, arguments);
  }

  (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_createClass_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(MetaService, [{
    key: "getServiceInfo",
    value: function () {
      var _getServiceInfo = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee() {
        var result, shutDownAt, openAt, status;
        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this._get("".concat(config_constants_server__WEBPACK_IMPORTED_MODULE_3__/* .SERVER_JSON */ .kU, "?time=").concat(Date.now()));

              case 2:
                result = _context.sent;

                if (result) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", null);

              case 5:
                shutDownAt = config_constants_server__WEBPACK_IMPORTED_MODULE_3__/* .STAGING_MODE */ .$P ? 1000000000000 : result.from_time * 1000;
                openAt = config_constants_server__WEBPACK_IMPORTED_MODULE_3__/* .STAGING_MODE */ .$P ? 1000000000000 : result.to_time * 1000;
                status = config_constants_server__WEBPACK_IMPORTED_MODULE_3__/* .STAGING_MODE */ .$P ? false : (result === null || result === void 0 ? void 0 : result.status) === -1;
                return _context.abrupt("return", {
                  shutDownAt: shutDownAt,
                  openAt: openAt,
                  isEnableMaintenanceMode: status
                });

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getServiceInfo() {
        return _getServiceInfo.apply(this, arguments);
      }

      return getServiceInfo;
    }()
  }, {
    key: "getMetaData",
    value: function () {
      var _getMetaData = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee2() {
        var result;
        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this._request(config_constants_server__WEBPACK_IMPORTED_MODULE_3__/* .APIEndpointEnum.Meta */ .zK.Meta, {
                  code: 'POKER'
                }, {
                  baseURL: config_constants_server__WEBPACK_IMPORTED_MODULE_3__/* .BASE_API_HUNNY */ .lY || config_constants_server__WEBPACK_IMPORTED_MODULE_3__/* .BASE_API */ .t3
                });

              case 2:
                result = _context2.sent;

                if (result) {
                  _context2.next = 5;
                  break;
                }

                return _context2.abrupt("return", null);

              case 5:
                return _context2.abrupt("return", result.data);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getMetaData() {
        return _getMetaData.apply(this, arguments);
      }

      return getMetaData;
    }()
  }, {
    key: "getTokenInUsdPrices",
    value: function () {
      var _getTokenInUsdPrices = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().mark(function _callee3(tokens) {
        var result;
        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_1___default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return _BaseRequest__WEBPACK_IMPORTED_MODULE_4__/* .hunnyAxios.get */ .g.get(config_constants_server__WEBPACK_IMPORTED_MODULE_3__/* .APIEndpointEnum.TokenUsdPrices */ .zK.TokenUsdPrices, {
                  params: {
                    ids: tokens.map(function (token) {
                      var _token$coinGeckoInfo;

                      return (_token$coinGeckoInfo = token.coinGeckoInfo) === null || _token$coinGeckoInfo === void 0 ? void 0 : _token$coinGeckoInfo.id;
                    }).filter(function (id) {
                      return id;
                    }).join(','),
                    vs_currencies: 'usd'
                  },
                  transformResponse: _mapper_Mapper__WEBPACK_IMPORTED_MODULE_6__/* ["default"].getMapper */ .Z.getMapper(config_constants_server__WEBPACK_IMPORTED_MODULE_3__/* .APIEndpointEnum.TokenUsdPrices */ .zK.TokenUsdPrices)
                });

              case 3:
                result = _context3.sent;

                if (result) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", null);

              case 6:
                return _context3.abrupt("return", result.data);

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", null);

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[0, 9]]);
      }));

      function getTokenInUsdPrices(_x) {
        return _getTokenInUsdPrices.apply(this, arguments);
      }

      return getTokenInUsdPrices;
    }()
  }]);

  return MetaService;
}(_HunnyPokerRequest__WEBPACK_IMPORTED_MODULE_5__/* .HunnyPokerRequest */ .y);

var instance = new MetaService();
/* harmony default export */ __webpack_exports__["Z"] = (instance);

/***/ }),

/***/ 24722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ fetchSystemData; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var services_MetaService__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31055);



function fetchSystemData() {
  return _fetchSystemData.apply(this, arguments);
}

function _fetchSystemData() {
  _fetchSystemData = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
    var result;
    return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return services_MetaService__WEBPACK_IMPORTED_MODULE_1__/* ["default"].getServiceInfo */ .Z.getServiceInfo();

          case 2:
            result = _context.sent;
            return _context.abrupt("return", result);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchSystemData.apply(this, arguments);
}

/***/ }),

/***/ 44602:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ usePollSystemData; },
/* harmony export */   "w": function() { return /* binding */ useSystemData; }
/* harmony export */ });
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50029);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var state__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82813);
/* harmony import */ var state_app_hooks__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37850);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13974);
/* harmony import */ var _calls_fetchSystemData__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24722);







var useSystemData = function useSystemData() {
  var system = (0,state__WEBPACK_IMPORTED_MODULE_2__/* .useAppSelector */ .CG)(function (state) {
    return state.system;
  });
  var serverTimeMargin = (0,state__WEBPACK_IMPORTED_MODULE_2__/* .useAppSelector */ .CG)(function (state) {
    return state.app.serverTimeMargin;
  }) || 0;
  var isServiceShutdown = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    if (system !== null && system !== void 0 && system.isEnableMaintenanceMode) {
      var rightJustNow = new Date().getTime() + serverTimeMargin;
      var shutDownTime = system.serviceShutdownAt + serverTimeMargin;
      var openTime = system.serviceOpenAt + serverTimeMargin;

      if (rightJustNow > shutDownTime && rightJustNow < openTime) {
        return true;
      }

      return false;
    }

    return false;
  }, [system, serverTimeMargin]);
  return (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function () {
    return {
      serviceShutdownAt: system.serviceShutdownAt + (serverTimeMargin || 0),
      serviceOpenAt: system.serviceOpenAt + serverTimeMargin,
      isEnableMaintenanceMode: system.isEnableMaintenanceMode && new Date().getTime() + serverTimeMargin < system.serviceOpenAt + serverTimeMargin,
      isServiceShutdown: isServiceShutdown
    };
  }, [system, serverTimeMargin, isServiceShutdown]);
};
var usePollSystemData = function usePollSystemData() {
  var dispatch = (0,state__WEBPACK_IMPORTED_MODULE_2__/* .useAppDispatch */ .TL)();
  var isInGame = (0,state_app_hooks__WEBPACK_IMPORTED_MODULE_3__/* .useIsInGame */ .Wq)();
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    var interval;

    var fetch = /*#__PURE__*/function () {
      var _ref = (0,_opt_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)( /*#__PURE__*/_opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var systemData;
        return _opt_app_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (isInGame) {
                  _context.next = 3;
                  break;
                }

                clearInterval(interval);
                return _context.abrupt("return");

              case 3:
                _context.next = 5;
                return (0,_calls_fetchSystemData__WEBPACK_IMPORTED_MODULE_5__/* .fetchSystemData */ .P)();

              case 5:
                systemData = _context.sent;

                if (systemData) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                dispatch((0,_actions__WEBPACK_IMPORTED_MODULE_4__/* .initSystemData */ .m)({
                  isEnableMaintenanceMode: systemData.isEnableMaintenanceMode,
                  serviceOpenAt: systemData.openAt,
                  serviceShutdownAt: systemData.shutDownAt
                }));

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetch() {
        return _ref.apply(this, arguments);
      };
    }();

    if (!isInGame) return;
    interval = setInterval(fetch, 300000);
    return function () {
      clearInterval(interval);
    };
  }, [dispatch, isInGame]);
};

/***/ })

}]);